import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import {
  Container,
  Overlay,
  Close,
  Header,
  Title,
  Confirm,
  Line,
  Form,
  Divider,
  TableGrid,
  TableText,
  IconWrapper,
  LighterText,
} from './RoleGuides.styles';

interface IRoleGuides {
  open: boolean;
  onClose: () => void;
}

export const RoleGuides = ({ open, onClose }: IRoleGuides) => {
  const portalDiv = document.getElementById('portal');

  const values = [
    {
      featureName: 'Manage Users',
      featureSubText: '',
      admin: true,
      editor: false,
      user: false,
      viewer: false,
    },
    {
      featureName: 'Invite Users',
      featureSubText: '',
      admin: true,
      editor: false,
      user: false,
      viewer: false,
    },
    {
      featureName: 'Manage Custom Fields',
      featureSubText: '',
      admin: true,
      editor: false,
      user: false,
      viewer: false,
    },
    {
      featureName: 'Manage Custom Status',
      featureSubText: '',
      admin: true,
      editor: false,
      user: false,
      viewer: false,
    },
    {
      featureName: 'Manage Tag Categories',
      featureSubText: '',
      admin: true,
      editor: false,
      user: false,
      viewer: false,
    },
    {
      featureName: 'Create Updates',
      featureSubText: '',
      admin: true,
      editor: false,
      user: false,
      viewer: false,
    },
    {
      featureName: 'Manage Updates',
      featureSubText: '',
      admin: true,
      editor: false,
      user: false,
      viewer: false,
    },
    {
      featureName: 'Edit Tags',
      featureSubText: '',
      admin: true,
      editor: true,
      user: false,
      viewer: false,
    },
    {
      featureName: 'Manage Inventory',
      featureSubText: '',
      admin: true,
      editor: true,
      user: false,
      viewer: false,
    },
    {
      featureName: 'Edit Inventory',
      featureSubText: '',
      admin: true,
      editor: true,
      user: true,
      viewer: false,
    },
    {
      featureName: 'Export Data ',
      featureSubText: '',
      admin: true,
      editor: true,
      user: true,
      viewer: false,
    },
    {
      featureName: 'Complete Updates',
      featureSubText: 'Assigned to user',
      admin: true,
      editor: true,
      user: true,
      viewer: false,
    },
    {
      featureName: 'View Inventory',
      featureSubText: '',
      admin: true,
      editor: true,
      user: true,
      viewer: true,
    },
    {
      featureName: 'View Updates',
      featureSubText: '',
      admin: true,
      editor: true,
      user: true,
      viewer: true,
    },
    {
      featureName: 'Manage Personal Settings',
      featureSubText: '',
      lastChild: true,
      admin: true,
      editor: true,
      user: true,
      viewer: true,
    },
  ];

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header>
              <Title>Comprehensive Role Guide</Title>
              <Close onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </Close>
            </Header>
            <Divider height="28px" />

            <TableGrid>
              <div />
              <TableText className="Admin">Admin</TableText>
              <TableText className="Editor">Editor</TableText>
              <TableText className="User">Member</TableText>
              <TableText className="Viewer">Viewer</TableText>
            </TableGrid>

            {values.map(item => (
              <TableGrid className="rowValues" lastChild={item.lastChild}>
                <TableText className="rowValues">
                  {item.featureName}{' '}
                  <LighterText>{item.featureSubText}</LighterText>
                </TableText>
                <IconWrapper className="admin">
                  {item.admin ? (
                    <BlueIcon icon="tick" color="#1371fe" />
                  ) : (
                    <div />
                  )}
                </IconWrapper>
                <IconWrapper>
                  {item.editor ? (
                    <BlueIcon icon="tick" color="#1371fe" />
                  ) : (
                    <div />
                  )}
                </IconWrapper>
                <IconWrapper>
                  {item.user ? (
                    <BlueIcon icon="tick" color="#1371fe" />
                  ) : (
                    <div />
                  )}
                </IconWrapper>
                <IconWrapper>
                  {item.viewer ? (
                    <BlueIcon icon="tick" color="#1371fe" />
                  ) : (
                    <div />
                  )}
                </IconWrapper>
              </TableGrid>
            ))}

            <Form>
              <Line>
                <Confirm type="button" onClick={() => onClose()}>
                  Got it!
                </Confirm>
              </Line>
            </Form>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
